module.exports = __webpack_public_path__ + "static/8-1968b0481db183eb101d5327d2f9f1ba.jpg";